var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "additionalWrap", class: _vm.$style.wrap }, [
    _c(
      "div",
      {
        ref: "additional",
        class: _vm.$style.additional,
        style: _vm.mainOffset
      },
      [
        _c(
          "v-radio-group",
          {
            ref: "options",
            staticClass: "no-message",
            class: _vm.$style.additionalOptions,
            attrs: { value: _vm.checkedModifierKey, row: "" },
            on: {
              change: function($event) {
                return _vm.$emit("input", $event)
              }
            }
          },
          [
            _c("span", {
              class: _vm.$style.itemPointer,
              style: _vm.triangleOffset
            }),
            _vm._v(" "),
            _vm._l(_vm.currentItemModifiers, function(modifierKey, index) {
              return _c("v-radio", {
                key: index + "-" + _vm.itemKey + "-modifier",
                staticClass: "customRadioBtn",
                class: _vm.$style.customRadio,
                attrs: {
                  label: _vm.modifiers[modifierKey].name,
                  value: modifierKey
                }
              })
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AdditionalOption.vue?vue&type=template&id=476f44a8&
// module id = null
// module chunks = 